import React from 'react';
import { InputNumber, Input, DatePicker, Select, Row, Col, Form } from 'antd';
import { formItemLayoutOffer } from './../theme';
import CustomAvatar from './../components/customAvatar';
import { allCurrencys, allPositions, allLocations } from './../utils/invoices';

const { Option } = Select;
const { TextArea } = Input;

function CreateOfferForm({clients, candidates, form, submitting}) {
  const { getFieldDecorator } = form;
  
  return (
    <div>
      <Row>
        <Col span={8}>
          <Form.Item {...formItemLayoutOffer} label="Client">
            {getFieldDecorator('client', {
              rules: [{ required: true, message: 'Please select client!' }],
            })(
              <Select
                disabled={submitting}
                optionFilterProp={'label'}
                showSearch={true}
                placeholder="Select client"
                style={{ width: '100%' }}
              >
                {
                  clients.map((i) => (
                    <Option label={i.name} key={i.id} value={i.id}>
                      <CustomAvatar
                        colourCode={i.name.charAt(0).toLowerCase()}
                        char={i.name.charAt(0).toUpperCase()}
                        charSize={11}
                        size={26}
                        src={i.avatar}
                      />
                      &nbsp;&nbsp;{i.name}
                    </Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...formItemLayoutOffer} label="Candidate">
            {getFieldDecorator('candidate', {
              rules: [{ required: true, message: 'Please select candidate!' }],
            })(
              <Select
                disabled={submitting}
                optionFilterProp={'label'}
                showSearch={true}
                placeholder="Select candidate"
                style={{ width: '100%' }}
              >
                {
                  candidates.map((i) => (
                    <Option label={`${i.firstname} ${i.lastname}`} key={i.id} value={i.id}>
                      <CustomAvatar
                        colourCode={i.firstname.charAt(0).toLowerCase()}
                        char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                        charSize={11}
                        size={26}
                        src={i.avatar}
                      />
                      &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                    </Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...formItemLayoutOffer} label="On Board">
            {getFieldDecorator('onBoard', {
            })(
              <DatePicker 
                disabled={submitting}
                style={{ width: '100%' }}
                placeholder="Select on board local time" />
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          <Form.Item {...formItemLayoutOffer} label="Location">
            {getFieldDecorator('location', {
              rules: [{ required: true, message: 'Please select location!' }],
            })(
              <Select
                disabled={submitting}
                showSearch={true}
                placeholder="Select location"
                style={{ width: '100%' }}
              >
                {
                  allLocations.map((i) => (
                    <Option key={i} value={i}>
                      {i}
                    </Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...formItemLayoutOffer} label="Position">
            {getFieldDecorator('position', {
              rules: [{ required: true, message: 'Please select position!' }],
            })(
              <Select
                disabled={submitting}
                showSearch={true}
                placeholder="Select position"
                style={{ width: '100%' }}
              >
                {
                  allPositions.map((i) => (
                    <Option key={i} value={i}>
                      {i}
                    </Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...formItemLayoutOffer} label="Service">
            {getFieldDecorator('service', {
              rules: [{ required: true, message: 'Please input service!' }],
            })(
              <Input
                autoComplete="off"
                disabled={submitting}
                placeholder="Input service"
                style={{ width: '100%' }}
              />
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          <Form.Item {...formItemLayoutOffer} label="Currency">
            {getFieldDecorator('currency', {
              rules: [{ required: true, message: 'Please select currency!' }],
            })(
              <Select
                disabled={submitting}
                showSearch={true}
                placeholder="Select currency"
                style={{ width: '100%' }}
              >
                {
                  allCurrencys.map((i) => (
                    <Option key={i} value={i}>
                      {i}
                    </Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...formItemLayoutOffer} label="Salary (Monthly)">
            {getFieldDecorator('salary', {
              rules: [{ required: true, message: 'Please input salary (monthly)!' }],
            })(
              <InputNumber
                autoComplete="off"
                disabled={submitting}
                placeholder="Input salary (monthly)"
                style={{ width: '100%' }}
                min={1} max={1000000} />
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...formItemLayoutOffer} label="Sign On Bonus">
            {getFieldDecorator('signOnBonus', {
            })(
              <InputNumber
                autoComplete="off"
                disabled={submitting}
                placeholder="Input sign on bonus"
                style={{ width: '100%' }}
                min={1} max={1000000} />
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          <Form.Item {...formItemLayoutOffer} label="Bonus">
            {getFieldDecorator('bonus', {
            })(
              <Input
                autoComplete="off"
                disabled={submitting}
                placeholder="Input bonus"
                style={{ width: '100%' }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...formItemLayoutOffer} label="Relocation">
            {getFieldDecorator('relocationAllowance', {
            })(
              <Input
                autoComplete="off"
                disabled={submitting}
                placeholder="Input relocation allowance"
                style={{ width: '100%' }}
              />
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item {...{
                labelCol: { span: 2 },
                wrapperCol: { span: 22 },
              }} label="Notes">
            {getFieldDecorator('note', {
            })(
              <TextArea placeholder="Write Notes Here" style={{resize: 'none'}} rows={2} autoComplete="off" disabled={submitting} />
            )}
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
}

export default CreateOfferForm;
